import React, { Component } from 'react';
import { Modal, Input, Radio, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class Approve extends Component {
    state = {
        record: {},
        saveParams: {},
        visible: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
            saveParams: {},
        });
    }

    cancel = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { curRole } = sessionStorage;
        const { record: { jdeMainApplyId }, saveParams } = this.state;
        const {
            approvalStatus,
            comments,
        } = saveParams;
        if (!approvalStatus) {
            message.warning('请选择审核结论');
            return;
        }
        if (approvalStatus == 'DISAGREE' && !comments) {
            message.warning('请输入审核不通过原因');
            return;
        }
        if (approvalStatus == 'REJECT' && !comments) {
            message.warning('请输入拒绝变更原因');
            return;
        }
        this.setState({ loading: true });
        let url = curRole === 'BO' ? API_URL.contract.boApproval : API_URL.contract.finApproval;
        const options = {
            method: 'post',
            url,
            data: {
                jdeMainApplyId,
                ...saveParams,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                    visible: false,
                }, () => {
                    this.props.loadData();
                })
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { saveParams } = this.state;
        saveParams[key] = e.target.value;
        this.setState({ saveParams });
    }

    render () {
        const { visible, record, saveParams } = this.state;
        const { investigationName, afterAlterContractCode } = record;
        const { approvalStatus, comments } = saveParams;
        const radioStyle = {
            display: 'block',
            paddingLeft: 10,
            height: 30,
            lineHeight: '30px',
        };
        return (
            <Modal
                title="审核"
                visible={visible}
                onOk={this.submit}
                onCancel={this.cancel}
                wrapClassName="vertical-center-modal"
                width="460px"
            >
                <div style={{ padding: '10px 20px', whiteSpace: 'initial' }}>
                    <div style={{ marginBottom: 8 }}>
                        是否通过项目【{investigationName}】的JDE主项目号变更申请【{afterAlterContractCode}】?
                    </div>
                    <Radio style={radioStyle} value='AGREE' checked={approvalStatus === 'AGREE'} onChange={e => this.handleInputChange(e, 'approvalStatus')}>审核通过</Radio>
                    <Radio style={radioStyle} value='DISAGREE' checked={approvalStatus === 'DISAGREE'} onChange={e => this.handleInputChange(e, 'approvalStatus')}>审核不通过</Radio>
                    {
                        approvalStatus == 'DISAGREE' &&
                        <div style={{paddingLeft: 30}}>
                            <Input
                                placeholder="请输入审核不通过原因"
                                style={{width: 240 }}
                                value={comments}
                                onChange={e => this.handleInputChange(e, 'comments')}
                            />
                        </div>
                    }
                    <Radio style={radioStyle} value='REJECT' checked={approvalStatus === 'REJECT'} onChange={e => this.handleInputChange(e, 'approvalStatus')}>拒绝变更</Radio>
                    {
                        approvalStatus == 'REJECT' &&
                        <div style={{paddingLeft: 30}}>
                            <Input
                                placeholder="请输入拒绝变更原因"
                                style={{width: 240}}
                                value={comments}
                                onChange={e => this.handleInputChange(e, 'comments')}
                            />
                        </div>
                    }
                </div>
            </Modal>
        )
    }
}

export default Approve;


// WEBPACK FOOTER //
// ./src/components/contractManagement/alterJdeCode/Approve.js